import React, { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const context = useAuth();
  const navigate = useNavigate();
  const myChannel = context?.myChannel;
  // useEffect(() => {
  //   // signOut(auth);
  // }, []);

  useEffect(() => {
    if (!context) return;
    if (context?.userRoles && context.userRoles.length === 0) {
      return context.myInvites && context.myInvites.length > 0 ? navigate("/dashboard/invitelist") : navigate("/dashboard/channels/onboarding");
    }
  }, [context]);

  return (
    <div className="max-w-4xl p-8 mx-auto bg-white rounded shadow">
      <div className="text-center">
        <h2 className="mb-4 text-xl font-semibold">Channel</h2>
        <p className="mb-8 text-gray-500">Total numbers since the start of the channel.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 mb-8 sm:grid-cols-2 lg:grid-cols-4">
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">{myChannel?.followerCount}</h3>
          <p className="text-gray-600">FOLLOWERS</p>
        </div>
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">350</h3>
          <p className="text-gray-600">SUBSCRIBERS</p>
        </div>
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">17.5%</h3>
          <p className="text-gray-600">UNSUBSCRIBE RATE</p>
        </div>
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">5.0%</h3>
          <p className="text-gray-600">UNFOLLOW RATE</p>
        </div>
      </div>
      <div className="mb-8 text-center">
        <h3 className="text-2xl font-bold">$3,500 USD</h3>
        <p className="text-gray-600">PAYOUTS</p>
      </div>
      <div className="text-center">
        <h2 className="mb-4 text-xl font-semibold">Content</h2>
        <p className="mb-8 text-gray-500">Total numbers since the start of the channel.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">598</h3>
          <p className="text-gray-600">PUBLISHED</p>
        </div>
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">350</h3>
          <p className="text-gray-600">FLAGGED</p>
        </div>
        <div className="p-4 text-center rounded shadow bg-gray-50">
          <h3 className="text-2xl font-bold">3</h3>
          <p className="text-gray-600">BLOCKED</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
